import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { searchUser } from '../../actions/userActions';
import UsersTable from './UsersTable';

class UserSearchResult extends Component {
  componentDidUpdate(){
    console.log("search Component Updated");
    console.log(this.props.user.users)
  }
  render(){
    return(
      <div>
        <h1>Search results for <span style={{fontWeight: 700}}>{this.props.query}</span></h1>
        { this.props.user.loading && <div>Loading...</div>}
        { !this.props.user.loading && this.props.user.status === 'search-success' &&
          <UsersTable
            refreshPage={this.props.refreshPage}
            headers={['Id', 'Name', 'Username', 'Email', '']}
            tableData={this.props.user.users}
            height={this.props.user.users.length * 48}
            editHandler={this.props.goToEditPage}
          />
        }
        { !this.props.user.loading && this.props.user.status === 'search-fail' &&
          <div>No user found!</div>
        }
      </div>
    )
  }
}


const mapStateToProps = state => ({ user: state.user.searched });
const mapDispatchToProps = { searchUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserSearchResult));



// WEBPACK FOOTER //
// ./src/components/Users/UserSearchResult.js